import React from 'react';
import axios from 'axios';
import SystemFunctions from "./SystemFunctions";
import StaffPublicKey from "../cert/staff";

const SERVER_PATH = 'https://staff.wog.games/server/';

export default class Server {

    static user_id = 0;
    static session_id = 0;
    static session_token = null;

    static QUERY_GET_DATA = 'getData';
    static QUERY_ACTIONS = 'actions';
    static QUERY_PURPOSE = 'purpose';
    static QUERY_TASKS = 'tasks';

    static ERROR_TEXT_CONNECTION = "Ошибка подключения к серверу! Попробуйте еще раз чуть позже...";

    static auth(login, password, response, error = () => {
    }) {
        SystemFunctions.generate256Key().then((newKey) => {
            let reqData = {
                login: login,
                password: password,
                responseKey: newKey,
            };
            let signPass = SystemFunctions.randomString(64);
            reqData.sign = SystemFunctions.hashSHA(JSON.stringify(reqData), signPass);
            reqData.signPass = signPass;
            axios.post(
                SERVER_PATH + 'auth.php',
                {
                    request: SystemFunctions.smartEncryptRsaPublic(JSON.stringify(reqData), StaffPublicKey),
                },
                {
                    headers: {},
                }
            ).then((resp) => {
                resp.data = SystemFunctions.decryptAES(resp.data, newKey);
                if (resp.data != null && resp.data != '') {
                    try {
                        resp.data = JSON.parse(resp.data);
                        response(resp);
                    } catch (e) {
                        error({
                            status: -1,
                            message: 'Error decryption',
                        });
                    }
                } else {
                    error({
                        status: -1,
                        message: 'Error decryption',
                    });
                }
            }).catch(error);
        });
    }

    static query(query, data, response, error = () => {
    }) {
        SystemFunctions.generate256Key().then((newKey) => {
            let reqData = {
                query: query,
                data: data,
                user_id: this.user_id,
                session: this.session_id,
                responseKey: newKey,
            };
            reqData.sign = SystemFunctions.hashSHA(JSON.stringify(reqData), this.session_id + '#' + this.user_id + '#' + this.session_token);
            axios.post(
                SERVER_PATH + 'api.php',
                {
                    request: SystemFunctions.smartEncryptRsaPublic(JSON.stringify(reqData), StaffPublicKey),
                },
                {
                    headers: {},
                }
            ).then((resp) => {
                if (resp.data === '@err_session') {
                    error({
                        status: -2,
                        message: 'Error session',
                    });
                    window.logout();
                    return;
                }
                resp.data = SystemFunctions.decryptAES(resp.data, newKey);
                if (resp.data != null && resp.data != '') {
                    try {
                        resp.data = JSON.parse(resp.data);
                        response(resp);
                    } catch (e) {
                        error({
                            status: -1,
                            message: 'Error decryption',
                        });
                    }
                } else {
                    error({
                        status: -1,
                        message: 'Error decryption',
                    });
                }
            }).catch(error);
        });
    }

}
